import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the FilterCasinoReportView.
 * @extends JetView
 */
export default class FilterCasinoReportView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing a date picker
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Makes the input read-only
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha"), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Center-left section containing product selection
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for product selection
                    name: 'ProductId',
                    localId: 'product:combo',
                    label: _('Producto'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options to be populated later
                },
            ],
        };

        // Center-right section containing provider selection
        const center_right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for provider selection
                    name: 'ProviderId',
                    localId: 'provider:combo',
                    label: _('Proveedor'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options to be populated later
                },
            ],
        };

        // Right section containing test selection
        const right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for test selection
                    name: 'IsTest',
                    localId: 'isTest:combo',
                    label: _('Es Test'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options to be populated later
                },
            ],
        };

        // Upper section combining all left, center, and right sections
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_right,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Localized button text
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'), // Localized button text
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Triggers filter event with form data
                    },
                },
            ],
        };

        // Returns the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Combines upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
